<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbItems">
    <v-row align="center" justify="center">
      <v-col md="4" class="d-inline-flex align-center">
        <div class="text-right mr-2">
          <v-avatar size="80" color="grey lighten-4">
            <v-img
              src="@/static/images/organization/default-logo.jpg"
              cover
              alt="avatar"
            >
            </v-img>
          </v-avatar>
        </div>
        <div class="font-4 text-left">
          <h5 class="font-3">
            {{ $store.state.shell.currentOrganizationName }}
          </h5>
        </div>
      </v-col>
      <v-col md="8">
        <p class="grey--text">
          This is where you can manage all your sales stages, service
          categories, products and services of the organization along with the
          crm members and their associated teams.
        </p>
      </v-col>
      <v-col md="12">
        <v-card class="elevation-5 mt-1">
          <v-tabs
            v-model="active"
            class="mx-0"
            color="primary"
            slider-color="grey"
            show-arrows
          >
            <v-tab
              v-for="(tab, index) in tabOptions"
              :key="index + `tabHeadings`"
              class="text-capitalize"
              @click="activeTab = tab.name"
            >
              <v-icon
                class="mr-2
                subheading"
                v-text="tab.icon"
              ></v-icon>
              {{ tab.name }}
            </v-tab>
            <v-tab-item
              v-for="(tab, index) in tabOptions"
              :key="index + `tabItems`"
            >
              <component
                :is="tab.component"
                v-if="tab.name === activeTab"
              ></component>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </vue-page-wrapper>
</template>
<script>
import ManageSalesStages from "@/components/crm/configuration/crm_settings/ManageSalesStages";
import ManageServiceCategory from "@/components/crm/configuration/crm_settings/ManageServiceCategory";
import ManageProductAndServices from "@/components/crm/configuration/crm_settings/ManageProductAndServices";
import ManageUsers from "@/components/crm/configuration/crm_settings/ManageUsers";
import ManageSalesTeam from "@/components/crm/configuration/crm_settings/ManageSalesTeam";
import ManageNotesTemplate from "@/components/crm/configuration/crm_settings/ManageNotesTemplate";
import ManageProcessTasks from "@/components/crm/configuration/crm_settings/ManageProcessTasks";

export default {
  components: {
    ManageSalesStages,
    ManageServiceCategory,
    ManageProductAndServices,
    ManageUsers,
    ManageSalesTeam,
    ManageNotesTemplate,
    ManageProcessTasks
  },
  data() {
    return {
      htmlTitle: "CRM Settings",
      tabOptions: [
        {
          name: "Sales Stages",
          component: "ManageSalesStages",
          icon: this.$getIcon("mdiAccountCircle")
        },
        {
          name: "Process Tasks",
          component: "ManageProcessTasks",
          icon: this.$getIcon("mdiFirework")
        },
        {
          name: "Service Category",
          component: "ManageServiceCategory",
          icon: this.$getIcon("mdiShape")
        },
        {
          name: "Product & Services",
          component: "ManageProductAndServices",
          icon: this.$getIcon("mdiEarth")
        },
        {
          name: "Sales Teams",
          component: "ManageSalesTeam",
          icon: this.$getIcon("mdiAccountMultiple")
        },
        {
          name: "Notes Template",
          component: "ManageNotesTemplate",
          icon: this.$getIcon("mdiFileMultiple")
        }
      ],
      orgSlug: this.$store.state.shell.currentOrganizationId,
      active: null,
      activeTab: "Sales Stages"
    };
  },
  computed: {
    breadCrumbItems() {
      return [
        { text: "Settings", disabled: true },
        {
          text: `${this.$store.state.shell.currentOrganizationName}`,
          disabled: true
        }
      ];
    }
  }
};
</script>
